
        import Symbol from "../../../svg-baker-runtime/browser-symbol.js";
        import sprite from "../../../svg-sprite-loader/runtime/browser-sprite.build.js";

        const symbol = new Symbol({
  "id": "icon-material-map",
  "use": "icon-material-map-usage",
  "viewBox": "0 -960 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 -960 960 960\" id=\"icon-material-map\"><path d=\"m612-113.78-263-93-176.85 70.52q-20.11 10.19-39.12-1.6T114.02-173v-558q0-14.91 8.58-26.59 8.57-11.67 22.49-17.15L349-846.22l263 92 175.85-70.52q20.11-9.19 39.24 2.1T846.22-788v565q0 13.15-8.7 22.71-8.69 9.55-21.61 14.03zm-34-83.85v-499.98l-196-66v499.98zm60 0 139.85-46.04v-507.22L638-697.61zm-455.85-12.72L322-263.63v-499.98l-139.85 46.28zM638-697.61v499.98zm-316-66v499.98z\" /></symbol>"
});
        sprite.add(symbol);

        function Icon({...props}) {
            return (
                <svg {...props} className="icon" fill="currentColor">
                    <use xlinkHref="#icon-material-map"/>
                </svg>
            );
        };

        Icon.id = "icon-material-map";

        export default Icon;
    